(function () {
  'use strict';

  function initCard(form) {
    if (!form || form.dataset.cardInit === '1') return;
    form.dataset.cardInit = '1';

    var sectionId = form.dataset.sectionId;
    var productId = form.dataset.productId;
    var soldOutText = form.dataset.soldOutText || 'Sold out';
    var addText = form.dataset.addText || 'DODAJ';

    var variantInput = form.querySelector('.card-product-variant-id');
    var variantsData = form.querySelector('[data-card-variants]');
    var variantSelects = form.querySelector('variant-selects');
    var fieldset = variantSelects ? variantSelects.querySelector('fieldset.card__size-buttons, fieldset') : null;
    var submitBtn = form.querySelector('.card__add-to-cart');
    var spinner = form.querySelector('.loading__spinner');

    var variants = [];
    if (variantsData) {
      try { variants = JSON.parse(variantsData.textContent) || []; } catch (e) { variants = []; }
    }
    var sizePos = variantSelects ? (parseInt(variantSelects.getAttribute('data-size-option-position'), 10) || 1) : 1;
    var optKey = 'option' + sizePos;

    function getSelectedSize() {
      if (!variantSelects) return null;
      var c = variantSelects.querySelector('fieldset input[type="radio"]:checked');
      return c ? c.value : null;
    }

    function findVariant() {
      var sizeVal = getSelectedSize();
      if (!sizeVal) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i][optKey]).trim() === String(sizeVal).trim()) return variants[i];
      }
      return null;
    }

    function refreshSizeAvailability() {
      if (!fieldset || !variants.length) return;
      var bySize = {};
      for (var vi = 0; vi < variants.length; vi++) {
        var vv = variants[vi];
        var sv = String(vv[optKey] || '').trim();
        if (!sv) continue;
        if (bySize[sv] === undefined) bySize[sv] = false;
        if (vv.available) bySize[sv] = true;
      }
      var radios = fieldset.querySelectorAll('input[type="radio"][name^="size-"]');
      for (var ri = 0; ri < radios.length; ri++) {
        var inp = radios[ri];
        if (!inp || !inp.value) continue;
        var key = String(inp.value).trim();
        var ok = bySize[key] === true;
        inp.classList.toggle('disabled', !ok);
        inp.disabled = !ok;
        if (!ok && inp.checked) {
          inp.checked = false;
          var ph = fieldset.querySelector('input[type="radio"][value=""]');
          if (ph) ph.checked = true;
        }
      }
    }

    function setBtnText(text) {
      if (!submitBtn) return;
      var span = submitBtn.querySelector('span:not(.sold-out-message):not(.loading__spinner)');
      if (span) span.textContent = text;
    }

    function updateForm() {
      var v = findVariant();
      if (!v) {
        if (variantInput) { variantInput.value = ''; variantInput.disabled = true; }
        if (submitBtn) {
          submitBtn.setAttribute('aria-disabled', 'true');
          setBtnText(addText);
        }
        return;
      }
      hideSizeError();
      if (variantInput) { variantInput.value = v.id; variantInput.disabled = !v.available; }
      if (submitBtn) {
        if (v.available) submitBtn.removeAttribute('aria-disabled');
        else submitBtn.setAttribute('aria-disabled', 'true');
        setBtnText(v.available ? addText : soldOutText);
      }
    }

    var sizeErrorEl = document.getElementById('size-error-' + sectionId + '-' + productId);
    var sizeErrorTimer = null;
    function showSizeError() {
      if (!sizeErrorEl) return;
      sizeErrorEl.classList.add('is-visible');
      clearTimeout(sizeErrorTimer);
      sizeErrorTimer = setTimeout(hideSizeError, 3000);
    }
    function hideSizeError() {
      if (!sizeErrorEl) return;
      sizeErrorEl.classList.remove('is-visible');
    }

    if (fieldset) fieldset.addEventListener('change', updateForm);
    if (variantSelects) variantSelects.addEventListener('change', updateForm);
    refreshSizeAvailability();
    updateForm();

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.getAttribute('aria-disabled') === 'true') {
          if (!getSelectedSize()) showSizeError();
          return;
        }
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    function setLoading(loading) {
      if (!submitBtn) return;
      if (loading) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
      } else {
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setLoading(true);
      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          setLoading(false);
          if (response.status) {
            alert(response.description || 'Błąd dodawania do koszyka');
            return;
          }
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            if (response.sections) {
              var targetDrawer = document.getElementById('CartDrawer');
              var targetIcon = document.getElementById('cart-icon-bubble');
              if (targetDrawer && response.sections['cart-drawer']) {
                var html = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
                var sourceDrawer = html.querySelector('#CartDrawer');
                if (sourceDrawer) targetDrawer.innerHTML = sourceDrawer.innerHTML;
              }
              if (targetIcon && response.sections['cart-icon-bubble']) {
                var htmlIcon = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
                var sourceIcon = htmlIcon.querySelector('#cart-icon-bubble');
                if (sourceIcon) targetIcon.innerHTML = sourceIcon.innerHTML;
              }
            }
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            cartDrawer.open();
          } else {
            window.location.reload();
          }
        })
        .catch(function (err) { setLoading(false); console.error(err); });
    });

    var colorLinks = form.querySelectorAll('.linked-color-swatches__swatch');
    var containerRow = form.querySelector('.card__size-add-row');
    var cardEl = form.closest('.card-wrapper') || (form.parentElement && form.parentElement.closest('.card-wrapper'));
    var variantOverlay = cardEl ? cardEl.querySelector('#variant-overlay-' + sectionId + '-' + productId) : null;
    var variantLabel = cardEl ? cardEl.querySelector('#variant-label-' + sectionId + '-' + productId) : null;
    var overlayImg = variantOverlay ? variantOverlay.querySelector('img') : null;

    if (colorLinks.length > 0 && containerRow) {
      colorLinks.forEach(function (link) {
        var imgSrc = link.getAttribute('data-variant-img');
        var colorName = link.getAttribute('data-variant-color');
        var isCurrent = link.getAttribute('data-is-current') === 'true';

        link.addEventListener('mouseenter', function () {
          if (window.innerWidth < 750) return;
          if (isCurrent) return;
          if (variantOverlay && overlayImg && imgSrc) {
            overlayImg.src = imgSrc;
            overlayImg.alt = colorName || '';
            variantOverlay.classList.add('is-hovered');
          }
          if (variantLabel && colorName) {
            variantLabel.textContent = colorName;
            variantLabel.classList.add('is-hovered');
          }
        });
        link.addEventListener('mouseleave', function () {
          if (variantOverlay) variantOverlay.classList.remove('is-hovered');
          if (variantLabel) variantLabel.classList.remove('is-hovered');
        });
        link.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      document.addEventListener('click', function (e) {
        if (containerRow.classList.contains('is-color-mode') && !containerRow.contains(e.target)) {
          containerRow.classList.remove('is-color-mode');
        }
      });
    }
  }

  function initAll(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('form.card-product-form[data-card-product-form]');
    for (var i = 0; i < forms.length; i++) initCard(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init for content loaded via AJAX (infinite scroll, filter, cart-drawer refresh)
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.addEventListener('selva:cards-loaded', function (e) { initAll(e.detail && e.detail.root); });
})();